const featuresPay = {
    featureTitle: '데이터 기반으로 비즈니스 의사결정하기',
    featureDescription:
        '어떤 제품이 잘 팔리고 가장 많은 이익을 내는지 파악하고, 언제 어디서나 재무 보고서에 액세스하세요. 손안의 비즈니스!',
    featureButton: "프리미엄 구독",
    featureStartingPrice: '80',
    featureEndingPart: '30',
    featureStaringText: '시작가',
    featureEndingText: '천 원',

    features: [
        {
            title: '무제한 상품 등록',
            description: '보유한 모든 상품을 제한 없이 추가할 수 있습니다.'
        },
        {
            title: '무제한 직원 등록',
            description: '비즈니스에 직원 및 관리자를 제한 없이 추가할 수 있습니다.'
        },
        {
            title: '무제한 이력 보기',
            description: '이전 재고 기록의 변경 사항을 제한 없이 확인할 수 있습니다.'
        },
        {
            title: '이력 필터',
            description: '유형, 카테고리, 직원, 날짜별로 이력을 쉽게 확인할 수 있습니다.'
        },
        {
            title: 'Excel로 다운로드',
            description: '한 번의 클릭으로 재고 기록 이력을 Microsoft Excel로 다운로드하세요.'
        },
        {
            title: 'PDF로 다운로드',
            description: '한 번의 클릭으로 최신 상품 및 재고 목록을 PDF로 다운로드하세요.'
        }
    ],
    warehousesGuide: [
        {
            desc: '더 나은 재고 관리를 위해 여러 창고를 생성하세요.'
        },
        {
            desc: '제품을 특정 위치에 할당하세요.'
        },
        {
            desc: '창고 전체의 재고 수준을 모니터링하세요.'
        }
    ],
    addVariantsGuide: [
        { desc: '사이즈, 색상 또는 소재 옵션을 추가하세요.' },
        { desc: '옵션별 재고 수준을 설정하세요.' },
        { desc: '창고 전반에 걸쳐 재고를 추적하세요.' }
    ]
}

export default featuresPay;
